"use client";
import { queryOptions, useQuery } from "@tanstack/react-query";
import useSession from "@/hooks/QueryHooks/useSession";
import { getPendingConnectionRequestsAction } from "../actions";

export const PENDING_CONNECTION_REQUESTS_QUERY_KEYS = {
  all: ["pending-connection-requests"] as const,
  getPendingConnectionRequests: () =>
    [
      ...PENDING_CONNECTION_REQUESTS_QUERY_KEYS.all,
      "list",
    ] as const,
};

export function getPendingConnectionRequestsOptions({
  userId,
  emailVerified,
}: {
  userId: string | undefined;
  emailVerified?: boolean;
}) {
  return queryOptions({
    queryKey:
      PENDING_CONNECTION_REQUESTS_QUERY_KEYS.getPendingConnectionRequests(),
    queryFn: getPendingConnectionRequestsAction,
    enabled: !!userId && !!emailVerified,
  });
}

export const usePendingConnectionRequests = () => {
  const { data: session } = useSession();
  return useQuery(
    getPendingConnectionRequestsOptions({
      userId: session?.id,
      emailVerified: !!session?.emailVerified,
    }),
  );
};
